import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

Swiper.use([Navigation]);

export default function () {
	const testimonialSliders = document.querySelectorAll(
		'.js-testimonial-slider'
	);

	testimonialSliders.forEach((carousel) => {
		if (carousel.querySelectorAll('.swiper-slide').length > 1) {
			const config = {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			};

			new Swiper(carousel, config);
		}
	});
}
